export const MODULE_ACCENT_COLORS = {
  suppliers: { main: '#EC4899', dark: '#DB2777' },
  recipes: { main: '#F97316', dark: '#EA580C' },
  lots: { main: '#14B8A6', dark: '#0D9488' },
  equipment: { main: '#6366F1', dark: '#4F46E5' },
  documents: { main: '#7C3AED', dark: '#6D28D9' },
  cleaningAreas: { main: '#0EA5E9', dark: '#0284C7' },
  temperature: { main: '#9333EA', dark: '#7E22CE' },
  cookingTemperature: { main: '#EA580C', dark: '#C2410C' },
  oilChange: { main: '#D97706', dark: '#B45309' },
  cleaning: { main: '#10B981', dark: '#059669' },
  pestControl: { main: '#8B5CF6', dark: '#7C3AED' },
  metalDetection: { main: '#0F766E', dark: '#115E59' },
  blastChilling: { main: '#0891B2', dark: '#0E7490' },
  goodsReceiving: { main: '#8B5CF6', dark: '#7C3AED' },
  haccpDashboard: { main: '#0D9488', dark: '#0F766E' },
  settings: { main: '#64748B', dark: '#475569' },
  emailPreferences: { main: '#4338CA', dark: '#3730A3' },
  profile: { main: '#64748B', dark: '#475569' },
  warehouse: { main: '#78716C', dark: '#57534E' },
  teamUsers: { main: '#4F46E5', dark: '#4338CA' },
  teamInvites: { main: '#F59E0B', dark: '#D97706' },
  teamConsultants: { main: '#0E7490', dark: '#155E75' },
  teamRoles: { main: '#7C3AED', dark: '#6D28D9' },
  adminSurveys: { main: '#BE185D', dark: '#9D174D' },
  surveys: { main: '#2563EB', dark: '#1D4ED8' },
  regulatoryNews: { main: '#0369A1', dark: '#075985' },
  customers: { main: '#16A34A', dark: '#15803D' },
  transportDocuments: { main: '#0891B2', dark: '#0E7490' },
  menus: { main: '#E11D48', dark: '#BE123C' },
  notifications: { main: '#C026D3', dark: '#A21CAF' },
  ingredients: { main: '#65A30D', dark: '#4D7C0F' },
  prepackagedLabels: { main: '#A16207', dark: '#854D0E' },
  mySites: { main: '#4F46E5', dark: '#4338CA' },
  // Deep orange — stesso accento admin di `drawer-route-config.tsx` e delle
  // pagine `/admin/**`, qui come token importabile invece di un letterale
  // `#E65100` duplicato in ogni file (piano dashboard-admin-insights, item 12).
  admin: { main: '#E65100', dark: '#BF360C' },
} as const;
